<template>
  <div
    :class="style.border"
    class="alert-wrapper bg-white flex-0 flex flex-col border-t-4 rounded shadow p-6"
  >
    <div>
      <h4><slot name="title" /></h4>
      <slot name="body" />
    </div>
    <div class="userIcon-row">
      <FeatherWrapper
        :icon="icon || 'users'"
        :classes="['h-5 w-5 block']"
        :class="style.mainColor"
      />
    </div>
  </div>
</template>

<script setup>
import "@/styles/layout/alertDialog.scss";
import { computed, defineProps } from "vue";

const props = defineProps({
  type: String,
  icon: String,
});

const types = {
  error: {
    mainColor: "text-rose-500",
    secondaryColor: "bg-rose-50",
    border: "border-rose-500",
  },
  info: {
    mainColor: "text-cobalt-500",
    secondaryColor: "bg-cobalt-50",
    border: "border-cobalt-500",
  },
  warning: {
    mainColor: "text-tangerine-500",
    secondaryColor: "bg-tangerine-50",
    border: "border-tangerine-500",
  },
};

const style = computed(() => {
  const type = types[props.type];
  if (!type) {
    throw new Error(`Invalid type passed : ${props.type}`);
  }
  return type;
});
</script>

<style>
.userIcon-row {
  background-color: #ffe8f1;
  height: 70px;
  width: 70px;
  border-radius: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.userIcon-row > img {
  width: 28px;
}

.alert-wrapper h4 {
  color: #7b736e;
  font-size: 24px;
  font-weight: 500;
}

.alert-wrapper p {
  color: #7b736e;
  font-size: 16px;
}

.blue-user-cion {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.blue-user-cion > p {
  margin-bottom: 0rem;
  color: #3377ff;
  font-weight: 600;
  font-size: 16px;
}
</style>

<!-- FFE8F1 -->
